import React from "react";
import { User } from "../../slices/usersSlice";
import UserManagementActionMenu from "../UserManagementActionMenu/UserManagementActionMenu";
import { Column } from "@/components/Datatable/types";
import GravatarAvatar from "@/components/GravatarAvatar/GravatarAvatar";

interface CreateUsersColumnsProps {
  handleEdit: (uuid: string) => void;
}

export function createUsersColumns({
  handleEdit,
}: CreateUsersColumnsProps): Column<User>[] {
  return [
    {
      header: "Name",
      accessorKey: "firstName",
      enableSorting: true,
      cell: ({ row }) => {
        const user = row.original;
        return (
          <div className="flex items-center gap-2.5">
            <GravatarAvatar
              email={user.email}
              firstName={user.firstName}
              lastName={user.lastName}
              size="sm"
            />
            <span>
              {user.firstName} {user.lastName}
            </span>
          </div>
        );
      },
    },
    {
      header: "Email",
      accessorKey: "email",
      enableSorting: true,
    },
    {
      header: "Role",
      accessorKey: "roleLabel",
      enableSorting: true,
      cell: ({ row }) => {
        const roleLabel = row.original.roleLabel;
        return roleLabel || <span className="text-muted-foreground">—</span>;
      },
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const userItem = row.original;

        return (
          <UserManagementActionMenu
            employeeUuid={userItem.employeeUuid || ""}
            onEdit={handleEdit}
          />
        );
      },
    },
  ];
}
